export const getLanguageDisplayName = (
  languageCode: string,
  uiLocale: string,
): string => {
  if (!languageCode) {
    return '';
  }

  const fallback = languageCode.toUpperCase();

  try {
    const displayNames = new Intl.DisplayNames([uiLocale], {
      type: 'language',
    });
    const name = displayNames.of(languageCode);

    if (!name || name.toLowerCase() === languageCode.toLowerCase()) {
      return fallback;
    }

    // Intl returns lowercase native names in some locales ("русский").
    return name.charAt(0).toLocaleUpperCase(uiLocale) + name.slice(1);
  } catch {
    return fallback;
  }
};
